import * as React from "react";
import { DSEagerModelProps, WithEagerDependentSelectionsProviderModel } from "./DependentSelectionsEagerModel";
import DependentSelectionsFluentUI from "./DependentSelectionsFluentUIView";

type DependentSelectionsEagerModelFluentUIViewProps = DSEagerModelProps;

const DependentSelectionsEagerModelFluentUIView: React.FunctionComponent<
  DependentSelectionsEagerModelFluentUIViewProps
> = (props) => {
  return (
    <WithEagerDependentSelectionsProviderModel {...props}>
      {(modelProvider) => <DependentSelectionsFluentUI {...modelProvider}></DependentSelectionsFluentUI>}
    </WithEagerDependentSelectionsProviderModel>
  );
};

export default DependentSelectionsEagerModelFluentUIView;
